export const Regex = {
  pinCode: /^[1-9][0-9]{5}$/gm,
  aadhaarNumber: /^[2-9]{1}[0-9]{3}[0-9]{4}[0-9]{4}$/,
  abhaNumber: /^[0-9]{2}[0-9]{4}[0-9]{4}[0-9]{4}$/,
  phoneNumber: /^\+[1-9]{1}[0-9]{11,14}$/,
  healthId:
    /^(?=.{8,18}$)(?!.*\..*\.)(?!.*_.*_)(?!.*[._]$)(?!^[._])[A-Za-z0-9._]+$/,
  // eslint-disable-next-line
  address: /^[A-Za-z0-9\s,.'\/()]+$/,
  password:
    // eslint-disable-next-line
    /^(?!.*(.)\1{2,})(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[^A-Za-z0-9])[A-Za-z0-9!@#$%^&*()\-=+\[\]{};:'",.<>?~\\]{8,}$/,
  // password: /^[A-Za-z](?!^\d)(?!.*\.$)[A-Za-z0-9.]{3,}\d?$/,
  // password: /^(?=.*[a-z])(?=.*[0-9])(?=.*[A-Z])(?=.*\d)(?=.*[@#$%^&+=]).{4,}$/,
  // eslint-disable-next-line
  email: /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/,
  name: /\d/,
  // eslint-disable-next-line
  requestDenyReason: /^[a-zA-Z0-9_\-@,. ":]{1,255}$/
};
